import { SECTION_PROPS } from '../../config/schemas';

export const personalizedSectionValidator = (props) => {
    SECTION_PROPS.validateSync(props);
};
